import React from 'react';
import './Button.css';

interface ButtonProps {
  value: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'cancel';
  size?: 'small' | 'medium' | 'large';
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset' | 'link';
  className?: string;
  icon?: React.ReactNode;
  linkHref?: string;
  style?: React.CSSProperties; // ← ajouté
  targetBlank?: boolean;
  title?: string;
}

const Button: React.FC<ButtonProps> = ({
  value,
  variant = 'primary',
  size = 'medium',
  onClick,
  disabled = false,
  type = 'button',
  className = '',
  icon,
  linkHref,
  style,
  targetBlank = true,
  title
}) => {
  if (type === 'link' && linkHref) {
    return (
      <a
        href={linkHref}
        target={targetBlank ? "_blank" : undefined}
        rel={targetBlank ? "noopener noreferrer" : undefined}
        className={`button ${variant} ${size} ${className}`}
        style={style} // ← appliqué
      >
        {icon && <span className="button-icon">{icon}</span>}
        {value}
      </a>
    );
  }

  return (
    <button
      className={`button ${variant} ${size} ${className}`}
      onClick={onClick}
      disabled={disabled}
      type={type}
      style={style} // ← appliqué
      title={title}
    >
      {icon && <span className="button-icon">{icon}</span>}
      {value}
    </button>
  );
};

export default Button;